export default __webpack_public_path__ + "static/media/100.6bd2245d.jpeg";